export function select2Sort(data){
    return data.sort(function(a, b) {
        return a.text < b.text ? -1 : a.text > b.text ? 1 : 0
    })
}

export function removeProtocol(url) {
    if (!url) {
        return ''
    }

    return url.replace(/(^\w+:|^)\/\//, '')
}

export function getTenantId(){
    let host = window.location.host;
    let parts = host.split('.');
    let subDomainLength = 3; // without www
    let wwwSubDomainLength = 4; // with www

    if(window.location.hostname === 'localhost'){
        return 'app.'
    }

    if(parts.length === subDomainLength && parts[0] !== 'www'){
        return parts[0] + "."
    }else if(parts.length === wwwSubDomainLength && parts[0] === 'www'){
        return parts[1] + "."
    }

    if(parts[0] && parts[0] !== "www"){
        return parts[0] + "."
    }

    return window.location.hostname === 'localhost' ? 'app.' : ""
}

export function sortArrayObjectByKey(array, level, key){
    if(!level){
        level = 'desc'
    }

    if(!key){
        key = 'created_at'
    }

    let sort = () => {}

    if(level === 'desc'){
        sort = (a,b) => new Date(b[key]) - new Date(a[key])
    }else{
        sort = (a,b) => new Date(a[key]) - new Date(b[key])
    }

    return array.sort(sort);
}

export function addStyleToTag(tag, style, value){
    let element = $(tag)

    if(!element){
        return;
    }

    element.css(style, value)
}

export function sortArrayObjectByCreatedAt(array, level){
    if(!level){
        level = 'desc'
    }

    let sort = () => {}

    if(level === 'desc'){
        sort = (a,b) => new Date(b.created_at) - new Date(a.created_at)
    }else{
        sort = (a,b) => new Date(a.created_at) - new Date(b.created_at)
    }

    return array.sort(sort);
}

export function sort(arr , arrayFilters){
    return arr.sort((a, b) => {
        const aIndex = arrayFilters.indexOf(a.status);
        const bIndex = arrayFilters.indexOf(b.status);
        if (aIndex === -1) {
            return 1;
        }
        if (bIndex === -1) {
            return -1;
        }
        return aIndex - bIndex;
    });
}

export const goBack = () => {
    window.history.back();
}
